import { Box, Center, Flex, Text } from "@chakra-ui/layout";
import { Select } from "@chakra-ui/select";
import React from "react";
import { useTranslation } from "react-i18next";

export const LanguagePicker: React.FC = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const languages = {
        sq: "🇦🇱 shqip",
        en: "🇺🇸 english",
        mk: "🇲🇰 македонски"
    };

    return (
        <Flex>
            <Center w="100px">
                <Text>{ t("language") }:</Text>
            </Center>
            <Box flex="1">
                <Select
                    variant="outline"
                    placeholder={ `${languages[currentLanguage]} (${t("selected")})` }
                    onChange={ (e) => {
                        const updatedLang = e.target.value;
                        i18n.changeLanguage(updatedLang);
                        localStorage.setItem("selected-language", updatedLang);
                    } }
                >
                    <option value="sq">{ languages["sq"] }</option>
                    <option value="en">{ languages["en"] }</option>
                    <option value="mk">{ languages["mk"] }</option>
                </Select>
            </Box>
        </Flex>
    );
};
